var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"post_tile",class:[this.background_colour, this.mode, { featured: _vm.isFeatured() }],on:{"mouseover":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}},[(_vm.isFeatured() && _vm.isDesktop)?_c('a',{staticClass:"featured-tile inner",attrs:{"href":_vm.extractUrl(_vm.permalink)}},[_c('div',{staticClass:"left"},[(
					(_vm.video && _vm.video.video_url != '') ||
					(_vm.video && _vm.video.video_file != '')
				)?_c('div',{staticClass:"tile-image",class:{
					hover: _vm.hover === true,
				},style:({
					'--gallery-background': 'url(' + _vm.image + ')',
				})},[(
						(_vm.video && _vm.video.video_url != '') ||
						(_vm.video && _vm.video.video_file != '')
					)?_c('video-modal',{attrs:{"has_border":'no',"video_poster":_vm.image,"video_source":_vm.video.video_url || _vm.video.video_file
							? _vm.video.video_url || _vm.video.video_file.url
							: false}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tile-image",class:{
					hover: _vm.hover === true,
					fallback: !_vm.image,
				},style:({
					'--gallery-background': 'url(' + _vm.image + ')',
				})},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"alt":_vm.name}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"right"},[(
					(_vm.tag && _vm.tag.some((e) => e.slug != 'uncategorised')) ||
					(_vm.tag && _vm.tag.some((e) => e.slug != 'all'))
				)?_c('div',{staticClass:"tag_container"},_vm._l((_vm.tag.filter((tag) => tag.slug !== 'all')),function(tag_item,index){return _c('h5',{key:index,class:tag_item.slug,domProps:{"innerHTML":_vm._s(
						tag_item.name != 'Uncategorised' || tag_item.name != 'All'
							? tag_item.name
							: null
					)}})}),0):_vm._e(),_vm._v(" "),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.name)}}),_vm._v(" "),_c('span',{staticClass:"subtitle",domProps:{"innerHTML":_vm._s(_vm.short_description)}}),_vm._v(" "),_c('primary-button',{attrs:{"label":'Read More',"link":_vm.permalink,"theme":"dark"}}),_vm._v(" "),_vm._t("default")],2)]):(!_vm.isFeatured() || !_vm.isDesktop)?_c('a',{staticClass:"inner",attrs:{"href":_vm.extractUrl(_vm.permalink)}},[(
				(_vm.tag && _vm.tag.some((e) => e.slug != 'uncategorised')) ||
				(_vm.tag && _vm.tag.some((e) => e.slug != 'all'))
			)?_c('div',{staticClass:"tag_container"},_vm._l((_vm.tag.filter((tag) => tag.slug !== 'all')),function(tag_item,index){return _c('h5',{key:index,class:tag_item.slug,domProps:{"innerHTML":_vm._s(
					tag_item.name != 'Uncategorised' || tag_item.name != 'All'
						? tag_item.name
						: null
				)}})}),0):_vm._e(),_vm._v(" "),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.name)}}),_vm._v(" "),(
				(_vm.video && _vm.video.video_url != '') || (_vm.video && _vm.video.video_file != '')
			)?_c('div',{staticClass:"tile-image",class:{
				hover: _vm.hover === true,
			},style:({
				'--gallery-background': 'url(' + _vm.image + ')',
			})},[(
					(_vm.video && _vm.video.video_url != '') ||
					(_vm.video && _vm.video.video_file != '')
				)?_c('video-modal',{attrs:{"has_border":'no',"video_poster":_vm.image,"video_source":_vm.video.video_url || _vm.video.video_file
						? _vm.video.video_url || _vm.video.video_file.url
						: false}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tile-image",class:{
				hover: _vm.hover === true,
				fallback: !_vm.image,
			},style:({
				'--gallery-background': 'url(' + _vm.image + ')',
			})},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"alt":_vm.name}}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"subtitle",domProps:{"innerHTML":_vm._s(_vm.short_description)}}),_vm._v(" "),_c('primary-button',{attrs:{"label":'Read More',"link":_vm.permalink,"theme":"dark"}}),_vm._v(" "),_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/PostTile.vue